/*
 * @Author: shaozongyao
 * @Date: 2021-11-29 17:50:44
 * @LastEditTime: 2021-11-30 16:32:33
 * @LastEditors: your name
 */
import request from '../request'
export function getCode (data) {
  return request({
    url: '/app/user/login/getJoinActivityMobileCode',
    method: 'post',
    params: data
  })
}

export function joinActivity (data) {
  return request({
    url: '/app/riding/gold/getActicityRidingGold',
    method: 'post',
    data
  })
}

export function queryInsure (id) {
  return request({
    url: '/app/order/queryInsure',
    method: 'get',
    params: {
      orderId: id
    }
  })
}
